import { render } from "./Activities.vue?vue&type=template&id=a1554248&scoped=true"
import script from "./Activities.vue?vue&type=script&lang=js"
export * from "./Activities.vue?vue&type=script&lang=js"

import "./Activities.vue?vue&type=style&index=0&id=a1554248&scoped=true&lang=scss"

import exportComponent from "/Users/jaxz/Desktop/wangyan-campaign/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1554248"]])

export default __exports__